import { CmsTeaserPresentation } from "@/gen/realtime";
import { generateImageUrl } from "@/utils/image";

function teaserAspectRatio(presentation: CmsTeaserPresentation): number {
    switch (presentation.t) {
        case "defaultWide":
            return 16 / 9;
        case "posterMd":
            return 1 / 1;
        default:
            return 4 / 6;
    }
}

export function teaserImageUrlWithRatio(
    presentation: CmsTeaserPresentation,
    imageId: string
): string {
    const width = 100;
    const ratio = teaserAspectRatio(presentation);
    const height = width / ratio;

    switch (presentation.t) {
        case "original":
            return generateImageUrl({
                imageId,
                width,
            });
        default:
            return generateImageUrl({
                imageId,
                width,
                height,
                fit: "crop",
            });
    }
}
